import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { CoeRoutingModule } from './coe-routing.module';
import { CoeListComponent } from './coe-list/coe-list.component';
import { CoeCreateComponent } from './coe-create/coe-create.component';

@NgModule({
  declarations: [CoeListComponent, CoeCreateComponent],
  imports: [
    CommonModule,
    CoeRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class CoeModule { }
